import ReactGA from 'react-ga4';

// Master switch for Google Analytics. While false, no data is sent to GA.
const GA_ENABLED = false;

let _isIntialized = false;
let _customerId;
let _companyName;

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (GA_ENABLED && measurementId && !_isIntialized) {
    _isIntialized = true;
    ReactGA.initialize(measurementId);
  }
};

export const setGACustomer = (customerId, companyName) => {
  if (!_isIntialized) {
    return;
  }

  ReactGA.set({ user_id: customerId });
  _customerId = customerId;
  _companyName = companyName;
};

export const sendGACustomEvent = (eventName, options) => {
  if (!_isIntialized) {
    return;
  }
  options = options || {};
  options.customer_id = _customerId;
  options.company_name = _companyName;
  ReactGA.event(eventName, options);
};
